module.exports = __webpack_public_path__ + "assets/functionalityLogOut-3e9a77.svg";